<template>
<v-app>

        <Drawer current_item="menu_dashboard"></Drawer>
<v-main class="ml-6 mr-6">

    
        <v-row align="end" justify="space-between">
        <v-col cols="12" md="8" class="text-md-h4 text-h5" align="left">
            {{ $t('Menu_Dashboard') }}
            </v-col>
        <v-col cols="12" md="4" align="left">
            <FragmentSelectStation :station_code="$route.params.station_code" @onchange="onStationChange"></FragmentSelectStation>
        </v-col>
        </v-row>

        <v-divider class="mb-6"></v-divider>

        <v-tabs v-model="tab" class="mb-4">
        <v-tab
            v-for="item in tabs"
            :key="item.value"
        >
            {{ item.text }}
        </v-tab>
    </v-tabs>

                    <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="item in tabs"
                :key="item.value"
              >

    <div v-if="item.value=='dashboard'">
        <ReportDashboard :station_code="$route.params.station_code"></ReportDashboard>
    </div>

    <div v-if="item.value=='reportAppointmentList'">
        <ReportAppointmentList :station_code="$route.params.station_code"></ReportAppointmentList>
    </div>

    <div v-if="item.value=='reportAppoinment'">
        <ReportAppointment :station_code="$route.params.station_code"></ReportAppointment>
    </div>

    <div v-if="item.value=='reportActivateBehavior'">
        <ReportActivateBehavior :station_code="$route.params.station_code"></ReportActivateBehavior>
    </div>

    <div v-if="item.value=='reportAppointmentBehavior'">
        <ReportAppointmentBehavior :station_code="$route.params.station_code"></ReportAppointmentBehavior>
    </div>

    <div v-if="item.value=='reportMember'">
        <ReportMember :station_code="$route.params.station_code"></ReportMember>
    </div>

    <div v-if="item.value=='reportAppointmentManage'">
        <ReportAppointmentManage :station_code="$route.params.station_code"></ReportAppointmentManage>
    </div>
    <div v-if="item.value=='staffLog'">
        <StaffLog :station_code="$route.params.station_code"></StaffLog>
    </div>
    <div v-if="item.value=='reportLine'">
        <ReportLine :station_code="$route.params.station_code"></ReportLine>
    </div>

    </v-tab-item>
</v-tabs-items>

</v-main>
</v-app>
</template>

<script>
import FragmentSelectStation from '@/components/Common/FragmentSelectStation.vue'
import Drawer from '@/components/Drawer.vue'

import ReportDashboard from './ReportDashboard'
import ReportAppointmentList from './ReportAppointmentList'
import ReportActivateBehavior from './ReportActivateBehavior'
import ReportMember from './ReportMember'
import ReportAppointmentManage from './ReportAppointmentManage'
import ReportAppointment from './ReportAppointment'
import ReportAppointmentBehavior from './ReportAppointmentBehavior'
import StaffLog from './StaffLog'
import ReportLine from './ReportLine'

export default {
    components: {
        Drawer,
        FragmentSelectStation,
        ReportDashboard,
        ReportMember,
        ReportAppointment,
        ReportActivateBehavior,
        ReportAppointmentBehavior,
        ReportAppointmentManage,
        StaffLog,
        ReportAppointmentList,
        ReportLine
    },
    data: () => ({
        tab : "",
        tabs : [
                {value: 'dashboard', text: 'สรุปรวมรายงาน'},
                {value: 'reportAppointmentList', text: 'รายละเอียดนัดหมายรายวัน'},
                {value: 'reportMember', text: 'รายงานจำนวนสมาชิก'},
                {value: 'reportAppoinment', text: 'รายงานจำนวนนัดหมายแต่ละวัน'},
                {value: 'reportActivateBehavior', text: 'รายงานพฤติกรรมการมาใช้บริการ'},
                {value: 'reportAppointmentBehavior', text: 'รายงานพฤติกรรมการสร้างนัดหมาย'},
                {value: 'reportAppointmentManage', text: 'รายงานจัดพฤติกรรมการจัดการนัดหมาย'},
                {value: 'reportLine', text: 'รายงานการส่งข้อความทาง Line'},
                {value: 'staffLog', text: 'บันทึกการทำงานของเจ้าหน้าที่'},
            ],
    }),
    methods: {
        onStationChange(station){
            document.location = station.station_code
        }
    },
}
</script>